import React from 'react';

const NotFound = () => (
    <section id="not-found">
        <h1>404</h1>
        <p className="dash">&mdash;</p>
        <p>Hey, get outta here!</p>
    </section>
);

export default NotFound;